<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">咨询师排班</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh" @selection-change="(val) =>{ delList = val }">
          <template #dayOfWeek="{ row }">
            <div>
              {{ getFind(row.dayOfWeek) }}
            </div>
          </template>
          <template #isEnabled="{ row }">
            <el-switch v-model="row.isEnabled" disabled />
          </template>
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_edit(row)"
            >编辑</el-button>
            <ConfirmButton icon="Delete" link @confirm="click_delete(row)">删除</ConfirmButton>
          </template>
        </MyTable>
        <MyPagination :params="paginationParams" :total="total" @get-list="getList" ref="paginationRef" />
      </div>
    </div>

    <!-- 新增 -->
    <Dialog
      v-model="addVisible"
      :title="title"
      top="5vh"
      width="50%"
    >
      <el-form :model="form" label-width="auto" ref="myFormRef" :rules="addUserForm">
        <el-form-item label="咨询师用户:" prop="consultantId">
          <el-select v-model="form.consultantId" placeholder="请选择" style="width: 240px">
            <el-option
              v-for="item in doctorOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="预约结束日期:" prop="generateEndDate">
          <el-date-picker
            style="width: 240px"
            v-model="form.generateEndDate"
            type="date"
            placeholder="请选择"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>

        <el-form-item label="排班规则:">
          <div v-for="(item, index) in form.rules" :key="index" style="margin-bottom: 20px;">
            <el-row align="middle" gutter="10">
              <!-- 星期 -->
              <el-col :span="5">
                <el-form-item :prop="`rules.${index}.dayOfWeek`" :rules="ruleRequired">
                  <el-select v-model="item.dayOfWeek" placeholder="请选择星期" style="width: 140px;">
                    <el-option
                      v-for="item in dayOfWeekList"
                      :key="item.id"
                      :label="item.week"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 开始时间 -->
              <el-col :span="5">
                <el-form-item :prop="`rules.${index}.startTime`" :rules="ruleRequired">
                  <el-time-select
                    v-model="item.startTime"
                    style="width: 100%"
                    placeholder="开始时间"
                    start="08:30"
                    step="00:15"
                    end="18:30"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="1" style="text-align:center">-</el-col>

              <!-- 结束时间 -->
              <el-col :span="5">
                <el-form-item :prop="`rules.${index}.endTime`" :rules="ruleRequired">
                  <el-time-select
                    v-model="item.endTime"
                    style="width: 100%"
                    placeholder="结束时间"
                    start="08:30"
                    step="00:15"
                    end="18:30"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="3" style="text-align:center">是否启用:</el-col>
              <el-col :span="2" class="text-center">
                <el-switch v-model="item.isEnabled" />
              </el-col>

              <el-col :span="3" class="text-center" style="display: flex;align-items: center;justify-content: space-between;">
                <el-link type="primary" @click="click_add">新增</el-link>
                <el-link type="danger" @click="deleteRule(index)">删除</el-link>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>

      <div class="submit-buttons" style="text-align:right;margin-top:20px;">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" @click="click_confirm">确定</el-button>
      </div>
    </Dialog>

    <!-- 编辑 -->
    <Dialog
      v-model="editVisible"
      :title="title"
      top="5vh"
      width="50%"
    >
      <el-form :model="editForm" label-width="auto" ref="editFormRef" :rules="editUserForm">
        <el-form-item label="咨询师用户:" prop="consultantId">
          <el-select v-model="editForm.consultantId" placeholder="请选择" style="width: 240px">
            <el-option
              v-for="item in doctorOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="预约结束日期:" prop="generateEndDate">
          <el-date-picker
            style="width: 240px"
            v-model="editForm.generateEndDate"
            type="date"
            placeholder="请选择"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>

        <el-form-item label="排班规则:">
          <div>
            <el-row align="middle" gutter="10">
              <!-- 星期 -->
              <el-col :span="5">
                <el-form-item prop="editForm.dayOfWeek">
                  <el-select v-model="editForm.dayOfWeek" placeholder="请选择星期" style="width: 140px;">
                    <el-option
                      v-for="item in dayOfWeekList"
                      :key="item.id"
                      :label="item.week"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 开始时间 -->
              <el-col :span="5">
                <el-form-item prop="editForm.startTime">
                  <el-time-select
                    v-model="editForm.startTime"
                    style="width: 100%"
                    placeholder="开始时间"
                    start="08:30"
                    step="00:15"
                    end="18:30"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="1" style="text-align:center">-</el-col>

              <!-- 结束时间 -->
              <el-col :span="5">
                <el-form-item prop="editForm.endTime">
                  <el-time-select
                    v-model="editForm.endTime"
                    style="width: 100%"
                    placeholder="结束时间"
                    start="08:30"
                    step="00:15"
                    end="18:30"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="3" style="text-align:center">是否启用:</el-col>
              <el-col :span="2" class="text-center">
                <el-switch v-model="editForm.isEnabled" />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>

      <div class="submit-buttons" style="text-align:right;margin-top:20px;">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="handleEditConfirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import { ref, reactive, computed, nextTick } from "vue";
import authApi from "@/api/auth";
import { postSaveRules, getConsultantSchedule, deleteConsultantSchedule,putConsultantSchedule } from "@/api/consultant.js";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";

const doctorOptions = ref([]);
const title = ref("新增");
const myFormRef = ref(null);
const editFormRef = ref(null);

// 搜索表单
const queryForm = reactive({
  itemList: [
    {
      type: "Select",
      label: "咨询师用户：",
      prop: "ConsultantId",
      options: doctorOptions,
      attrs: { placeholder: "请选择咨询师" },
    },
    {
      type: "Button",
      value: "查询",
      attrs: { icon: "Search" },
      events: {
        click(formData) {
          Object.assign(paginationParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "新增",
      attrs: { icon: "Plus" },
      events: {
        click() {
          addVisible.value = true;
          reset()
          title.value = "新增";
        },
      },
    },
    {
      type: "Button",
      value: "重置",
      attrs: { icon: "RefreshLeft" },
      events: {
        click(formData) {
          formData.ConsultantId = "";
          paginationParams.ConsultantId = "";
        },
      },
    },
  ],
});

// 新增表单校验规则
const addUserForm = reactive({
  consultantId: [{ required: true, message: "咨询师用户不能为空", trigger: "change" }],
  generateEndDate: [{ required: true, message: "预约结束日期不能为空", trigger: "change" }],
});

// 编辑表单校验规则
const editUserForm = reactive({
  consultantId: [{ required: true, message: "咨询师用户不能为空", trigger: "change" }],
  generateEndDate: [{ required: true, message: "预约结束日期不能为空", trigger: "change" }],
  dayOfWeek: [{ required: true, message: "不能为空", trigger: "change" }],
  startTime: [{ required: true, message: "不能为空", trigger: "change" }],
  endTime: [{ required: true, message: "不能为空", trigger: "change" }],
});

// 数组项必填规则
const ruleRequired = ref([{ required: true, message: "该项不能为空", trigger: "change" }]);

// 表格配置
const tableOptions = reactive({
  colList: [
    { type: "selection", width: 50 },
    { type: "index", label: "序号", width: 60 },
    { label: "预约结束时间", prop: "generateEndDate" },
    { label: "星期", type: "slot", slot_name: "dayOfWeek" },
    { label: "开始时间", prop: "startTime" },
    { label: "结束时间", prop: "endTime" },
    { label: "是否启用", type: "slot", slot_name: "isEnabled" },
    { type: "slot", slot_name: "handler", label: "操作" },
  ],
  tableData: [],
});

// 获取咨询师列表
const doctorData = () => {
  let obj = { Type: 2, SkipCount: 0, MaxResultCount: 999 };
  authApi.getUserList(obj).then((res) => {
    doctorOptions.value = res.data.items.map((item) => ({
      label: item.userName,
      value: item.id,
      ...item,
    }));
  });
};
doctorData();

// 新增表单
const form = ref({
  consultantId: "",
  generateEndDate: "",
  rules: [{ dayOfWeek: "", startTime: "", endTime: "", isEnabled: true }],
});

// 编辑表单
const editForm = ref({});

// 星期列表
const dayOfWeekList = ref([
  { week: "星期一", id: 1 },
  { week: "星期二", id: 2 },
  { week: "星期三", id: 3 },
  { week: "星期四", id: 4 },
  { week: "星期五", id: 5 },
  { week: "星期六", id: 6 },
  { week: "星期日", id: 0 },
]);

// 转换星期
const getFind = (id) => {
  const target = dayOfWeekList.value.find((item) => item.id === id);
  return target ? target.week : "";
};

// 新增规则行
const click_add = () => {
  form.value.rules.push({
    dayOfWeek: "",
    startTime: "",
    endTime: "",
    isEnabled: true,
  });
};

// 删除规则行
const deleteRule = (index) => {
  if (form.value.rules.length <= 1) {
    ElMessage.warning("至少保留一条排班规则");
    return;
  }
  form.value.rules.splice(index, 1);
}




// 新增弹窗
const addVisible = ref(false);
const reset=()=>{
      form.value = {
        consultantId: "",
        generateEndDate: "",
        rules: [{ dayOfWeek: "", startTime: "", endTime: "", isEnabled: true }],
      };
}
// 新增提交
const click_confirm = () => {
  myFormRef.value.validate(async (valid) => {
    if (valid) {
      const params = {
        consultantId: form.value.consultantId,
        generateEndDate: form.value.generateEndDate,
        rules: form.value.rules.map(item=>{
              item.consultantId=form.value.consultantId
              item.generateEndDate=form.value.generateEndDate
              return item
        }),
      };
      await postSaveRules(params);
      ElMessage.success("操作成功");
      addVisible.value = false;
      getList();
    }
  });
};

// 编辑
const editVisible = ref(false);

const click_edit = (row) => {
  editVisible.value = true;
  title.value = "编辑";
  console.log(row)
  Object.assign(editForm.value,row);
};

// 编辑提交
const handleEditConfirm = () => {
  editFormRef.value.validate(async (valid) => {
    if (valid) {
      await putConsultantSchedule(editForm.value);
      ElMessage.success("编辑成功");
      editVisible.value = false;
      getList();
    }
  });
};

// 删除
const delList = ref([]);
const click_delete = (row) => {
  deleteConsultantSchedule(row.id).then(() => {
    ElMessage.success("删除成功");
    getList();
  });
};

// 分页
const paginationParams = reactive({ ConsultantId: "" });
const paginationRef = ref();
const total = ref(0);

const getList = (params) => {
  getConsultantSchedule(params || paginationParams).then((res) => {
    total.value = res.data.totalCount;
    if(res.data.items.length>0){
      tableOptions.tableData = res.data.items.map(item=>{
          item.startTime=item.startTime.slice(0,5)
          item.endTime=item.endTime.slice(0,5)
          return item
      });
    }else{
      tableOptions.tableData=[]
    }
  });
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
.content-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.query {
  margin-bottom: 20px;
}
.table {
  margin-top: 10px;
}
</style>